import FacebookIcon from "../assets/social/facebook.svg";
import HuddIcon from "../assets/social/hudd.svg";
import InstagramIcon from "../assets/social/instagram.svg";
import LinkedinIcon from "../assets/social/linkedin.svg";
import BOB from "./bobConstants";
import { LINK_EXTERNAL, LINK_NEW_WINDOW } from "./umbracoConstants";

export const SOME = [
  { src: LinkedinIcon, link: { url: BOB.SOCIAL.LINKEDIN, ...LINK_EXTERNAL, ...LINK_NEW_WINDOW }, alt: "LinkedIn" },
  { src: FacebookIcon, link: { url: BOB.SOCIAL.FACEBOOK, ...LINK_EXTERNAL, ...LINK_NEW_WINDOW }, alt: "Facebook" },
  { src: InstagramIcon, link: { url: BOB.SOCIAL.INSTAGRAM, ...LINK_EXTERNAL, ...LINK_NEW_WINDOW }, alt: "Instagram" },
  { src: HuddIcon, link: { url: BOB.SOCIAL.HUDD, ...LINK_EXTERNAL, ...LINK_NEW_WINDOW }, alt: "Hudd" },
];

export const LOGO_FOOTER = "LOGO_FOOTER";
export const LOGO_FOOTER_MOBILE = "LOGO_FOOTER_MOBILE";
